module.exports = __webpack_public_path__ + "assets/1.5f467fd8.jpg";